// extracted by mini-css-extract-plugin
export var dropdown = "_rx-0";
export var imageWrapper = "_rx-3";
export var itemNameContainer = "_rx-1";
export var productImage = "_rx-2";
export var spinnerWrapper = "_rx-4";